import './css/main.css';
import Glide from '@glidejs/glide';
import "./responsive-menu";
import ajaxLoadMore from './ajax-load-more';
import officeMap from './office-map';

'use strict';


console.log( 'script online.' );

// Glide JS for Home Banner
const headerSlider = document.querySelector( '.glide--header' );
if( headerSlider ) {
    let headerGlide = new Glide( headerSlider, {
        type        : 'carousel',
        perView     : 1,
    } );
    headerGlide.mount();
}

// Glide JS for Brand
const brandSlider = document.querySelector( '.glide--brand' );
if( brandSlider ) {
    let brandGlide = new Glide( brandSlider, {
        type        : 'carousel',
        perView     : 4,
        gap         : 30,
        bound       : true,
        breakpoints : {
            800: {
                perView : 3
            },
            640: {
                focusAt : 'center',
                perView : 2,
                gap     : 7
            }
        }
    } );
    brandGlide.mount();
}


// Glide JS for Featured Products
var featuredProductsSlider = document.querySelector( '.glide--featured-products' );
if( featuredProductsSlider ) {
    let featuredProductsGlide = new Glide( featuredProductsSlider, {
        type    : 'carousel',
        perView : 3,
        gap     : 30,
        bound   : true,
        breakpoints : {
            800: {
                focusAt : 'center',
                perView : 1,
                gap     : 24,
            }        
        }
    } );
    featuredProductsGlide.mount();
}

// Glide JS for Testimonials
var testimonialSlider = document.querySelector( '.glide--testimonials' );
if( testimonialSlider ) {
    let testimonialsGlide = new Glide( testimonialSlider, {
        type    : 'carousel',
        perView : 1,
        bound   : true
    } );
    testimonialsGlide.mount();
}

// Glide JS for News Gallery
var newsGallerySlider = document.querySelector( '.glide--news-gallery' );
if( newsGallerySlider ) {
    let newsGallerySliderGlide = new Glide( newsGallerySlider, {
        type    : 'slider',
        perView : 1,
        gap     : 30,
        breakpoints : {
            800: {
                focusAt : 'center',
                gap     : 7,
                peek: {
                    before: 0,
                    after: 75
                }
            }        
        }
    } );
    newsGallerySliderGlide.mount();
}

// Glide JS for Community Partners
var communityPartnersSlider = document.querySelector( '.glide--partners' );
if( communityPartnersSlider ) {
    let communityPartnersGlide = new Glide( communityPartnersSlider, {
        type    : 'carousel',
        perView : 3,
        gap     : 30,
        breakpoints : {
            800: {
                focusAt : 'center',
                perView : 2,
                gap     : 7,
            }        
        }
    } );
    communityPartnersGlide.mount();
}

// Glide JS for Testimonials
var productImageSlider = document.querySelector( '.glide--product-image' );
if( productImageSlider ) {
    let productImageGlide = new Glide( productImageSlider, {
        type    : 'carousel',
        perView : 1,
        bound   : true
    } );
    productImageGlide.mount();
}

// const Modal = ( el ) => {
//     const modal = document.querySelector( el );
//     return modal;
// }

// console.log( Modal );

document.addEventListener("DOMContentLoaded", function() {

    // Search Modal
    const searchModal = document.querySelector( '#Search' );
    const searchButton = document.querySelector( '#SearchButton' );
    const searchClose = document.querySelector( '#CloseSearchModal' );
    
    if( searchButton ) {
        // Event Open Modal when search button clicked
        searchButton.onclick = function() {
            searchModal.style.display="block";
        }
    
        // Event Close Modal when close button clicked.
        searchClose.onclick = function() {
            searchModal.style.display="none";
        }
    
        window.onclick = function(event) {
            if (event.target == searchModal) {
                searchModal.style.display = "none";
            }
        } 
    }
});

document.addEventListener("DOMContentLoaded", function() {

    // Global Modal
    const regionModal = document.querySelector( '#Region' );
    const regionButtons = document.querySelectorAll( '#RegionButton' );
    const regionClose = document.querySelector( '#CloseRegionModal' );

    if( regionButtons ) {

        regionButtons.forEach( regionButton => { 
            // Event Open Modal when search button clicked
            regionButton.onclick = function() { regionModal.style.display="block"; }
        } );

        // Event Close Modal when close button clicked.
        regionClose.onclick = function() {    
            regionModal.style.display="none";
        }

        window.onclick = function(event) {
            if (event.target == regionModal) {
                regionModal.style.display = "none";
            }
        } 
    }

});

// Back to Top.
    // Get Class
    const backToTopButton = document.querySelector( '.back-to-top' );

    // Scroll Top Function
    const scrollToTop = () => {
        document.documentElement.scrollTop = 0;
    }

    // Click event run, scrollToTop Function.
    backToTopButton.addEventListener( 'click', scrollToTop );


// Lazy Load Iamge.
document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages;    

    if ("IntersectionObserver" in window) {
        lazyloadImages = document.querySelectorAll(".lazy");
        var imageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var image = entry.target;
                    if( image.dataset.src ) {
                        image.src = image.dataset.src;
                    }
                    image.classList.remove("lazy");
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach(function(image) {
            imageObserver.observe(image);
        });
    } else {  
        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazy");
        
        function lazyload () {
            if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }    

            lazyloadThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function(img) {
                    if(img.offsetTop < (window.innerHeight + scrollTop)) {
                        if( img.dataset.src ) {
                            img.src = img.dataset.src;
                        }
                        if( img.dataset.srcset ) {
                            img.srcset = img.dataset.srcset;
                        }
                        img.classList.remove('lazy');
                    }
                });
                if(lazyloadImages.length == 0) { 
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }

        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }
})

// Ajax Load More
document.addEventListener("DOMContentLoaded", function(event) {     
    ajaxLoadMore();
});

// History Functions.
document.addEventListener("DOMContentLoaded", function() {

    var decades = document.querySelectorAll( '.decade-wrapper' );

    var options = {};

    let observer = new IntersectionObserver( function( entries, observer ) {

        const bookmarks = document.querySelectorAll( '.year-bookmark' );

        entries.forEach( entry => {
            
            if( entry.isIntersecting ) {               
                
                entry.target.dataset.intersecting = true;

                let dataIntersectecting = entry.target.dataset.intersecting;
                let datadecade = entry.target.dataset.decade;

                if( dataIntersectecting ) {
                    bookmarks.forEach( bookmark => {
                        if( datadecade === bookmark.dataset.decadematch ) {
                            bookmark.classList.add( 'active' );
                        }
                    } );
                }

            } else {

                entry.target.dataset.intersecting = false;

                let dataIntersectecting = entry.target.dataset.intersecting;
                let datadecade = entry.target.dataset.decade;

                if( dataIntersectecting ) {
                    bookmarks.forEach( bookmark => {
                        if( datadecade === bookmark.dataset.decadematch ) {
                            if( bookmark.classList.contains( 'active' ) ) {
                                bookmark.classList.remove( 'active' );
                            }
                        }
                    } );
                }
            }

        } );           

    } , options );

    decades.forEach( decade => {
        observer.observe( decade );
    } );    

} );

// Load Office map in Contact Us.
officeMap();

// Filter for Brands
document.addEventListener("DOMContentLoaded", function() {
    const BrandFilter = document.querySelector( '#FilterBrands' );
    if( BrandFilter ) {
        // Initialize Variables.
        let sortOrder       = document.querySelector( '#order' );
        let submitSearch    = document.querySelector( '.innericon' );
        let textOrig        = document.querySelector( '.orig' );

        // Filter for Sort Results for Brands.
        sortOrder.addEventListener( 'change', ( e ) => {
            BrandFilter.submit();
        } );        
        
        // Submit when Magnifying Glass icon is clicked.
        submitSearch.addEventListener( 'click', ( e ) => {
            BrandFilter.submit();
        } );
        
        // Submit when Enter key is pressed.
        textOrig.addEventListener( 'keydown', ( e ) => {
            if( e.key === 'Enter' ) {
                BrandFilter.submit();
            }
        } );
        
    }    
} );

// Filter for Sort Results for Products.
document.addEventListener("DOMContentLoaded", function() {    
    const ProductFilter = document.querySelector( '#FilterProducts' );
    if( ProductFilter ) {
        // Initialize Variables.
        let sortOrder           = document.querySelector( '#order' );
        let sortCategories      = document.querySelector( '#Categories' );
        let submitSearch        = document.querySelector( '.innericon' );
        let textOrig            = document.querySelector( '.orig' );
        let url                 = new URL ( document.location );
        let urlSearchParams     = url.searchParams.get( 'phrase' );
        
        // Sort by Acending or Descending.
        sortOrder.addEventListener( 'change', ( e ) => {
            ProductFilter.submit();
        } );

        // Sort by Product Category.
        sortCategories.addEventListener( 'change', ( e ) => {
            ProductFilter.submit();
        } );        
        
        // Submit when Magnifying Glass icon is clicked.
        submitSearch.addEventListener( 'click', ( e ) => {
            ProductFilter.submit();
        } );
        
        // Set Value to Search Parameters.
        if( urlSearchParams !== null ) {
            textOrig.setAttribute( 'value', urlSearchParams );
        }
        
        // Submit when Enter key is pressed.
        textOrig.addEventListener( 'keydown', ( e ) => {
            if( e.key === 'Enter' ) {
                ProductFilter.submit();
            }
        } );
    
    }
} );

// Filter for Location in Contact Us page.
document.addEventListener("DOMContentLoaded", function() {
    const CountryFilter = document.querySelector( '#CountryFilter' );

    if( CountryFilter ) {
        // Initialize Variables.
        let SelectCountries = document.querySelector( '#SelectCountries' );
        let SelectStates    = document.querySelector( '#SelectStates' );

        // For Country Select.
        if( SelectCountries ) {
            // Submit when Country is chosen in Dropdown.
            SelectCountries.addEventListener( 'change', ( e ) => {
                CountryFilter.submit();
            } );
        }
        
        // For State Select.
        if( SelectStates ) {
            // Submit when State is chosen in Dropdown.
            SelectStates.addEventListener( 'change', ( e ) => {                
                CountryFilter.submit();
            } );
        }

    }
} );

// Region Indicator on Mobile.

const hookMenu = document.querySelector( 'nav#genesis-nav-primary > .wrap' );
if( hookMenu ) {
    // Create Element <div>
    let divElement = document.createElement( 'div' );
    let locationElement = document.createElement( 'p' );
    let locationlinkElement = document.createElement( 'a' );
    let regionElement = document.createElement( 'p' );

    locationlinkElement.setAttribute( 'id', 'RegionButton' );
    locationlinkElement.setAttribute( 'class', 'no-underline text-white' );

    // Add .region-indicator to created element of <div>
    divElement.classList.add( 'region-indicator' );

    // Add .location-heading
    locationElement.classList.add( 'location-heading' );

    regionElement.classList.add( 'region-now' );

    let locationContent = document.createTextNode( 'Location' );

    let siteRegion = document.querySelector( '#SiteRegion' ).innerHTML;
    let regionContent = document.createTextNode( siteRegion );

    locationElement.appendChild( locationlinkElement );
    locationlinkElement.appendChild( locationContent );

    regionElement.appendChild( regionContent );

    divElement.appendChild( locationElement );
    divElement.appendChild( regionElement );

    // Insert the created element after .wrap.
    hookMenu.insertBefore( divElement, hookMenu.nextSibling );
}

document.addEventListener("DOMContentLoaded", function( e ) {
    let getUrl = window.location;
    let fancyID = getUrl.hash;

    let brandID = document.querySelector( 'a[data-src="' + CSS.escape( fancyID ) + '"]' );

    if( fancyID && brandID ) {
        brandID.click();
    }
});

// Our History add class .alt-year
const years = document.querySelectorAll( '.year' );
if( years ) {
    let getUrl = window.location;

    // If page is /our-history
    if( getUrl.pathname === '/about-us/our-history/' ) {
        years.forEach( ( year, index ) => {            
            if( index % 2 !== 0 ) {
                year.classList.add( 'alt-year' );                
            } 
        } );
    }
}

document.addEventListener( "DOMContentLoaded", function( e ) {
    const contactForm = document.querySelector( '.catalogue-form-container > .wpcf7' );

    if( contactForm ) {
        contactForm.addEventListener( 'wpcf7mailsent', function( event ) {
          const thankYou        = document.querySelector( '.thank-you' );
          const downloadFile    = document.querySelector( '.download-file' );

          downloadFile.click();
          contactForm.classList.add( 'hidden' );
          thankYou.classList.remove( 'hidden' );

        }, false );
    }
});


document.addEventListener( "DOMContentLoaded", function( e ) {
    const singleProductImages = document.querySelectorAll( '.single-product .woocommerce-product-gallery img' );

    if( singleProductImages ) {
        singleProductImages.forEach( ( singleProductImage ) => {
            singleProductImage.removeAttribute( 'title' );
        } );
    }
    
});
